// @flow
import * as React from 'react'
import Link from 'ui/Link'
import { Text } from 'core/Text'
import UploadcareImg from 'ui/UploadcareImg'

import './BackToSchoolBanner.scss'

type Props = {}

export default class BackToSchoolBanner extends React.Component<Props> {
  render = () => {
    return (
      <div className="BackToSchoolBanner">
        <div className="BackToSchoolBanner-image">
          <UploadcareImg uuid="ffa8bd9e-6b8d-49f7-983d-f0b225eef80a" />
        </div>
        <Text>
          We're going Back to School Together! Get 25% off your first month of care |{' '}
          <Link
            native
            href="https://pages.wonderschool.com/back-to-school-together"
            className="BackToSchoolBanner-link"
          >
            Details here
          </Link>
        </Text>
        <div className="BackToSchoolBanner-image">
          <UploadcareImg uuid="cb570901-322e-46a1-84d7-a9d5ab938f50" />
        </div>
      </div>
    )
  }
}
